var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"read-more"},[_c('div',{staticClass:"read-more-teaser"},[_c('ce-renderer',{attrs:{"content":_vm.teaser}})],1),_vm._v(" "),(_vm.hiddenContent.length == 1)?_c('div',{staticClass:"read-more-hidden-content"},[_c('foldable',[_c('ce-renderer',{attrs:{"content":_vm.hiddenContent}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }